module.exports = __webpack_public_path__ + "static/media/rank-02-novice.d8e08eff.svg";